import './ConjugationTableColumn.css';
import ConjugationTableCell from './ConjugationTableCell';

function ConjugationTableColumn(props) {
  return (
    <div className="conjugation-table__column">
      {props.elements.map((elem, i) => {
        return <ConjugationTableCell
          textContent={elem.textContent}
          isColHeader={elem.isColHeader}
          isRowHeader={elem.isRowHeader}
        />
      })}
    </div>
  )
}

export default ConjugationTableColumn;
